export const tabGroups = () => {
    const tabGroup = document.querySelectorAll(".tab-group");

    if (tabGroup) {
        const tabGroupLists = document.querySelectorAll(".tab-group > [role='tablist']");
        const tabItems = document.querySelectorAll(".tab-group > [role='tablist'] > button");

        /* Add active class to first items, before anything clicked */
        for (const tabGroupList of Array.from(tabGroupLists)) {
            tabGroupList.querySelector("button:first-child").classList.add("active");
            tabGroupList.parentNode
                .querySelector(
                    "div[data-item=" + tabGroupList.querySelector("button:first-child").getAttribute("data-id") + "]"
                )
                .classList.add("active");
        }

        /* Attach click events to tab items */
        for (const tabItem of Array.from(tabItems)) {
            tabItem.addEventListener("click", event => {
                event.preventDefault();

                // Reset siblings
                const tabItemSiblings = tabItem.parentNode.querySelectorAll("button");
                for (const tabItemSibling of Array.from(tabItemSiblings)) {
                    tabItemSibling.classList.remove("active");
                    tabItemSibling.setAttribute("aria-current", "false");
                }
                // Add current class
                const ariaState = tabItem.getAttribute("aria-current") == "false" || false ? "page" : false;
                tabItem.setAttribute("aria-current", ariaState);
                tabItem.classList.add("active");

                // Show corresponding tab content
                const tabItemID = tabItem.getAttribute("data-id");
                const tabItemGroup = tabItem.closest(".tab-group");
                const tabItemGroupContents = tabItem.closest(".tab-group").querySelectorAll("div[data-item]");
                const tabItemContent = tabItemGroup.querySelector("div[data-item=" + tabItemID + "]");

                // Reset tab content
                for (const tabItemGroupContent of Array.from(tabItemGroupContents)) {
                    tabItemGroupContent.classList.remove("active");
                }

                // Show requested tab content
                tabItemContent.classList.add("active");
            });
        }
    }
};
